import { Controller } from "@hotwired/stimulus";

// Assure que le champ hidden `city` est mis à jour:
// - lors d'un clic sur une suggestion (géré nativement par stimulus-autocomplete via hidden target)
// - lors d'un blur sur le champ `city_suggestion` si aucune suggestion n'a été sélectionnée
export default class extends Controller {
  static targets = ["input", "hidden"];

  connect() {
    if (this.hasInputTarget) {
      this.onBlur = () => this.commitIfNeeded();
      this.onFocus = () => this.selectAll();
      this.onMouseUp = (e) => { e.preventDefault(); }; // keep selection on click
      this.inputTarget.addEventListener("blur", this.onBlur);
      this.inputTarget.addEventListener("focus", this.onFocus);
      this.inputTarget.addEventListener("mouseup", this.onMouseUp);
    }
  }

  disconnect() {
    if (this.hasInputTarget) {
      this.inputTarget.removeEventListener("blur", this.onBlur);
      this.inputTarget.removeEventListener("focus", this.onFocus);
      this.inputTarget.removeEventListener("mouseup", this.onMouseUp);
    }
  }

  selectAll() {
    try {
      this.inputTarget.select();
      // For Safari
      this.inputTarget.setSelectionRange(0, (this.inputTarget.value || "").length);
    } catch (_) {}
  }

  commitIfNeeded() {
    if (!this.hasHiddenTarget || !this.hasInputTarget) return;
    // Si l'utilisateur n'a pas cliqué une suggestion, prendre la première suggestion visible
    const results = this.element.querySelector("[data-autocomplete-target='results']");
    const firstOption = results ? results.querySelector("[role='option']") : null;
    const prev = (this.hiddenTarget.value || "").trim();
    if (firstOption) {
      const label = firstOption.getAttribute("data-autocomplete-label") || (firstOption.textContent || "").trim();
      const value = firstOption.getAttribute("data-autocomplete-value") || label;
      // Renseigner la saisie visible
      this.inputTarget.value = label;
      // Commit uniquement si la valeur change
      if (value.trim() !== prev) {
        this.hiddenTarget.value = value;
        this.hiddenTarget.dispatchEvent(new Event("input", { bubbles: true }));
        this.hiddenTarget.dispatchEvent(new Event("change", { bubbles: true }));
      }
      return;
    }
    // Sinon, si hidden est vide, recopier la valeur visible
    if (!this.hiddenTarget.value || (this.hiddenTarget.value || "").trim() === "") {
      const v = this.inputTarget.value || "";
      if (v.trim() !== prev) {
        this.hiddenTarget.value = v;
        this.hiddenTarget.dispatchEvent(new Event("input", { bubbles: true }));
        this.hiddenTarget.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }
  }
}


